import { connect } from "react-redux";

import * as userActions from "../../../services/users/actions";
import {
  gdpr_deactivate,
  gdpr_remove,
  gdpr_remove_borrower,
  get_banks,
  get_salesrepresentatives,
  manuallyMarkAsIdentified,
} from "../../system/actions";
import {
  remove_user_salesrepresentative,
  set_user_salesrepresentative,
} from "../../../services/users/actions";

function mapStateToProps(state) {
  return {
    users: state.users,
    mandatorError: state.users.mandatorAddError,
    mandatorRemoveError: state.users.mandatorRemoveError,
    availableBankAccounts: state.system.availableBankAccounts,
    system: state.system,
    salesRepresentatives: state.system.salesRepresentatives,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getSsn: (accountId) => {
      dispatch(userActions.account_info_fetch_ssn(accountId));
    },

    getUser: (accountId) => {
      dispatch(userActions.get_user_data_for_account_id(accountId));
    },
    manuallySetIsIdentified: (personId) => {
      dispatch(manuallyMarkAsIdentified(personId));
    },
    getRepresentatives: () => {
      dispatch(get_salesrepresentatives());
    },
    setRepresentative: (investorId, repId, changeDate) => {
      dispatch(set_user_salesrepresentative(investorId, repId, changeDate));
    },
    removeRepresentative: (investorId, changeDate) => {
      dispatch(remove_user_salesrepresentative(investorId, changeDate));
    },
    addBankAccount: (data, accountId) => {
      dispatch(userActions.add_bank_account(data, accountId));
    },
    getBanks: () => {
      dispatch(get_banks());
    },
    gdprRemove: (personId) => {
      dispatch(gdpr_remove(personId));
    },
    gdprDeactivate: (id) => {
      dispatch(gdpr_deactivate(id));
    },
    gdprRemoveBorrower: (ssn) => {
      dispatch(gdpr_remove_borrower(ssn));
    },
    setMinEffectiveInvestorLevel: (investorLevel, accountId) => {
      dispatch(
        userActions.set_user_investor_level_minEffecive(
          investorLevel,
          accountId,
        ),
      );
    },
    getInvestorTags: () => {
      dispatch(userActions.get_investor_tags());
    },
    setTagForInvestor: (tag, accountId) => {
      dispatch(userActions.set_user_investor_tag(tag, accountId));
    },
  };
}

export const UsersOverviewConnector = connect(
  mapStateToProps,
  mapDispatchToProps,
);
